import { __extends } from "tslib";
import { DeleteUserEndpointsRequest, DeleteUserEndpointsResponse } from "../models/index";
import { deserializeAws_restJson1DeleteUserEndpointsCommand, serializeAws_restJson1DeleteUserEndpointsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteUserEndpointsCommand = /** @class */ (function (_super) {
    __extends(DeleteUserEndpointsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteUserEndpointsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteUserEndpointsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteUserEndpointsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteUserEndpointsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteUserEndpointsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeleteUserEndpointsCommand(input, context);
    };
    DeleteUserEndpointsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeleteUserEndpointsCommand(output, context);
    };
    return DeleteUserEndpointsCommand;
}($Command));
export { DeleteUserEndpointsCommand };
//# sourceMappingURL=DeleteUserEndpointsCommand.js.map